'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _createReducer = require('../createReducer');

var _createReducer2 = _interopRequireDefault(_createReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setUtmCodes(utmCodesState) {
  if (process.env.REACT_APP_SERVER) {
    return utmCodesState;
  }

  var utmQuery = decodeURIComponent(window.location.search.substring(1));
  var utmVariables = utmQuery.split('&');
  var ParameterName = void 0;
  var newState = {};

  var getUTMValue = function getUTMValue(inputParameter) {
    for (var i = 0; i < utmVariables.length; i += 1) {
      ParameterName = utmVariables[i].split('=');
      if (ParameterName[0] === inputParameter) {
        return ParameterName[1] === null ? null : ParameterName[1];
      }
    }
    return undefined;
  };

  var valueExists = function valueExists(value) {
    return value != null && value !== '' && value !== undefined;
  };

  var utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  utmParams.forEach(function (param) {
    var pValue = getUTMValue(param);

    if (valueExists(pValue)) {
      window.localStorage.setItem(param, pValue);
      newState[param] = pValue;
    } else {
      var localValue = window.localStorage.getItem(param);
      if (valueExists(localValue)) {
        newState[param] = localValue;
      }
    }
  });

  return (0, _extends3.default)({}, utmCodesState, newState);
}

var reducer = (0, _createReducer2.default)({}, {
  '@@redux/INIT': setUtmCodes
});

exports.default = reducer;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/UTMCodes/reducer.js
// module id = 1020
// module chunks = 0